import * as React from 'react';
import { mergeRegister } from '@lexical/utils';
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_LOW,
} from 'lexical';
import type { LexicalEditor } from 'lexical';
import type { ToolbarHistoryController } from './types';

export function useToolbarHistory(
  editor: LexicalEditor
): ToolbarHistoryController {
  const [canRedo, setCanRedo] = React.useState(false);
  const [canUndo, setCanUndo] = React.useState(false);

  React.useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        CAN_UNDO_COMMAND,
        (payload) => {
          setCanUndo(payload);
          return false;
        },
        COMMAND_PRIORITY_LOW
      ),
      editor.registerCommand(
        CAN_REDO_COMMAND,
        (payload) => {
          setCanRedo(payload);
          return false;
        },
        COMMAND_PRIORITY_LOW
      )
    );
  }, [editor]);

  return {
    canRedo,
    canUndo,
  };
}
